import { BetPickDetail } from '@mobx/stores/kol/kol-store';
import { kolNonPageTracker } from '@src/adobe-launch/data-layer-provider';
import { TrackingEvent } from '@src/adobe-launch/types';
import { DeepReadonly } from '@src/utils/type-utils';
import { useTranslation } from 'next-i18next';
import React, { useMemo } from 'react';

type Props = {
    // striketype: 'new' | 'old';
    betpickDetail: DeepReadonly<BetPickDetail>;
};

const BetPickButton = ({ betpickDetail }: Props) => {
    const { betpick, race, raceDay } = betpickDetail;
    const { t } = useTranslation('kol');
    const isVoid = useMemo(
        () => betpick.buttonStatus?.value === 'VOID',
        [betpick.buttonStatus?.value]
    );

    const formatTrackingSelection = (value?: string, scratched?: boolean) => {
        if (!value) {
            return 'na';
        } else if (scratched) {
            return `${value}(${t('betpick.scratched')})`;
        } else {
            return value;
        }
    };

    if (isVoid) {
        return <div className='text-center font-bold py-1'>{t('betpick.void')}</div>;
    }
    switch (betpick.buttonStatus?.value) {
        case 'BetLink':
            return (
                <a
                    href={betpick.betlineUrl?.value}
                    target='_blank'
                    className='h-[30px] mt-[12px] bg-[#FFD505] text-[16px] rounded-full flex items-center justify-center font-medium'
                    onClick={() => {
                        const selections = [
                            formatTrackingSelection(
                                betpick.bankerRow?.value,
                                betpick.bankerRowSCR?.boolValue
                            ),
                            formatTrackingSelection(
                                betpick.selRow?.value,
                                betpick.selRowSCR?.boolValue
                            ),
                            formatTrackingSelection(
                                betpick.selRow2nd?.value,
                                betpick.selRow2ndSCR?.boolValue
                            ),
                            formatTrackingSelection(
                                betpick.selRow3rd?.value,
                                betpick.selRow3rdSCR?.boolValue
                            ),
                        ];
                        kolNonPageTracker({
                            eventID: TrackingEvent.BetPickCTA,
                            betLink: selections.join(','),
                            betType: betpick.betPickType?.targetItem?.betTypeName?.value,
                            raceID: `${raceDay?.name}/${race?.name}`,
                            kolName: betpick.kol?.targetItem?.name,
                        });
                    }}
                >
                    {t('betpick.betNow')}
                </a>
            );
        case 'Strike':
            return (
                <div
                    className='text-white font-bold text-[16px] absolute left-[-1px] top-[-1px]  rounded-br-lg bg-[#FF9900] py-1.5 pl-3 pr-2'
                    // className={`${
                    //     striketype === 'old'
                    //         ? 'text-center text-[#ff9c00] font-bold'
                    //         : ' text-white font-bold text-[16px] absolute left-[-1px] top-[-1px]  rounded-br-lg bg-[#FF9900] py-1.5 pl-3 pr-2'
                    // }`}
                >
                    {t('betpick.strike')} 🎉
                </div>
            );

        default:
            return <></>;
    }
};

export default BetPickButton;
